export const PATH_ERROR = "/error";
export const PATH_NOT_FOUND = "/:pathMatch(.*)*";
export const PATH_UNAUTHORIZED = "/unauthorized";
export const PATH_PERMISSIONS_ADMINISTRATION = "/permissions/administration";
export const PATH_PERMISSIONS_OPERATOR = "/permissions/operator";
